import { agentTypeParams, normalizeCollectionResponse } from 'api';
import { client, computeHeaders } from 'queries';

export const agentTypesQuery = async ({ req, params }) => {
	const headers = computeHeaders(req);
	const response = await client.apiRequest({
		url: '/agent-types',
		headers,
		params: { ...agentTypeParams, context: ['ssr'] },
	});
	return normalizeCollectionResponse(response);
};
